import { Container, Graphics, NineSliceSprite, Texture } from 'pixi.js';
import cloneDeep from 'lodash/cloneDeep';
import type { AnyModel } from './types/models';
import { ModelType } from './types/models';
import { copyContainerProps } from './copyContainerProps';
import { copySpriteProps } from './copySpriteProps';
import { copyTextProps } from './copyTextProps';
import { copyNineSlicePlaneProps } from './copyNineSlicePlaneProps';
import { copyGraphicsProps } from './copyGraphicsProps';
import { setHitArea } from './setHitArea';
import { getContainerInstance, getSpriteInstance, getTextInstance } from '../initPopulate';
import { setInteractivitySounds } from './setInteractivitySounds';
/* eslint-disable @typescript-eslint/no-explicit-any */

export const createView = (model: AnyModel<any>): { view: Container; object: unknown } => {
  let view;
  let object;

  switch (model.type) {
    case ModelType.Container:
      view = getContainerInstance(model);
      copyContainerProps(view, model);

      break;

    case ModelType.Sprite: {
      view = getSpriteInstance(model);
      copySpriteProps(view, model);
      break;
    }

    case ModelType.Text: {
      view = getTextInstance(model);
      copyTextProps(view, model);
      try {
        copyTextProps(view, cloneDeep(model));
      } catch (e) {
        console.error(e);
        console.log(JSON.stringify(model));
      }
      break;
    }

    case ModelType.NineSlicePlane:
      view = new NineSliceSprite({
        texture: Texture.from(model.texture),
      });
      copyNineSlicePlaneProps(view, model);
      break;

    case ModelType.Graphics: {
      view = new Graphics();
      copyGraphicsProps(view, model);
      break;
    }

    default:
      view = new Container();
      break;
  }

  view.name = model.name;
  setHitArea(view, model.hitArea);
  setInteractivitySounds(view, model);

  return { view, object: object ?? view };
};
